import { FileArrowUp, X } from "@phosphor-icons/react";
import CustomModal from "../../../components/UI/Modal/Modal";
import { useEffect, useState } from "react";
import Dropzone from "../../../components/UI/Dropzone/Dropzone";
import classes from "../../DRH/FichasColaborador/FichasColaborador.module.css";
import Input from "../../../components/UI/Input/Input";
import Button from "../../../components/UI/Button/Button";
import LoadingButton from "../../../components/UI/LoadingButton/LoadingButton";
import { toast } from "react-toastify";
import { createFileSstEvent } from "../../../axios/requests/qas";
import { useSelector } from "react-redux";

type Props = {
  isOpen: boolean;
  handleClose: any;
  event_id: number;
  getEventAttachments: any;
};

const ModalInsert: React.FC<Props> = ({
  isOpen,
  handleClose,
  event_id,
  getEventAttachments,
}) => {
  const user = useSelector((state: any) => state.user);
  const [attachment, setAttachment] = useState<File | null>(null);

  const [loading, setLoading] = useState<boolean>(false);

  const [body, setBody] = useState<{ nome_autor: string; idade_autor: number }>(
    {
      nome_autor: "",
      idade_autor: 0,
    }
  );

  async function createFile() {
    if (body.idade_autor > 12) {
      toast.error("A idade do autor não pode ser superior a 12 anos");
      return;
    }
    try {
      setLoading(true);

      const formData = new FormData();
      if (attachment) {
        formData.append("", attachment);
      }

      formData.append("nome_autor", body.nome_autor);
      formData.append("idade_autor", String(body.idade_autor));

      await createFileSstEvent(user.accessToken, event_id, formData);

      toast.success("Desenho submetido com sucesso");
      getEventAttachments();
      handleClose();
    } catch (err) {
      toast.error("Ocorreu um erro ao carregar o desenho");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!isOpen) {
      setAttachment(null);
      setBody({
        nome_autor: "",
        idade_autor: 0,
      });
    }
  }, [isOpen]);

  return (
    <CustomModal
      title={
        <div className="d-flex justify-content-center">
          <div className="d-flex flex-column align-items-center">
            <FileArrowUp size={27} color="var(--primary)" />
            <span className="fs-4 fw-bolder mt-2">Submeter desenho</span>
          </div>
        </div>
      }
      width="600px"
      isOpen={isOpen}
      handleClose={handleClose}
      footer={
        <div className="d-flex justify-content-end gap-3 mt-5">
          <LoadingButton
            loading={loading}
            title={"Enviar"}
            style={"btn btn-primary"}
            disabled={!attachment || !body.nome_autor || !body.idade_autor}
            submit
            form="submit_sst_event"
          />
          <Button
            title={"Voltar"}
            onClick={handleClose}
            style="btn btn-secondary"
          />
        </div>
      }
    >
      <div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            createFile();
          }}
          id="submit_sst_event"
        >
          <Dropzone
            onDrop={(values) => {
              if (!values?.length) {
                toast.error("Só é possível adicionar imagens");
                return;
              }
              if (values.length > 1) {
                toast.error("Nao pode adicionar mais de um desenho");
                return;
              }
              setAttachment(values[0]);
            }}
            accept={{
              "application/pdf": [],
              "image/*": [],
            }}
          >
            <div>
              <FileArrowUp size={80} />
              <p>
                Arrastar para aqui o desenho ou{" "}
                <strong
                  className="pointer"
                  style={{ textDecoration: "underline" }}
                >
                  escolher ficheiro
                </strong>
              </p>
            </div>
          </Dropzone>
          {attachment ? (
            <div className="text-align-start mb-5 mt-5">
              <p className="fs-6 fw-bold mb-3">Desenho anexado</p>

              <div className={classes.fileDiv}>
                <label className="d-flex justify-content-between mb-1">
                  {attachment.name}{" "}
                  <X
                    weight="bold"
                    onClick={() => {
                      setAttachment(null);
                    }}
                  />
                </label>
                <div className="bg-primary"></div>
              </div>
            </div>
          ) : null}

          <Input
            type={"text"}
            title="Autor do Desenho"
            state={body?.nome_autor}
            stateUpdate={(value: any) => {
              setBody({
                ...body,
                nome_autor: value,
              });
            }}
            space={"mt-10"}
            required
          />

          <Input
            type={"number"}
            title="Idade do Autor"
            state={body?.idade_autor}
            stateUpdate={(value: any) => {
              setBody({
                ...body,
                idade_autor: value,
              });
            }}
            space={"mt-5"}
            required
            max={12}
          />
        </form>
      </div>
    </CustomModal>
  );
};

export default ModalInsert;
